
import { RegionStub } from "../templates/fragments/region";
import { CountryBase } from "../templates/fragments/country";
import { monthSlugsWithOverview as monthSlugs } from './centralStore';
import { ResortBase } from "../templates/fragments/resort";
import { SearchResult } from "./textSearch";



export default ({ location, monthIndex, isCountryInstance, isResortInstance }: { location: RegionStub | CountryBase | ResortBase, monthIndex: number, isCountryInstance: boolean, isResortInstance?: boolean }): string => {
    let path;
    let continent = (location as CountryBase).continent || (location as RegionStub).country?.continent || (location as ResortBase).region.country.continent;
    if (isCountryInstance || (location as RegionStub).isCountry) {
        path = `/${continent}/${location.slug}-weather-${monthSlugs[monthIndex]}/`
    }
    else if (!isResortInstance) {
        path = `/${continent}/${(location as RegionStub).country.slug}/${location.slug}-weather-${monthSlugs[monthIndex]}/`
    }
    else {
        let pathBase;
        const resort = location as ResortBase;
        if (resort.region.isCountry) {
            pathBase = `/${continent}/${resort.region.slug}/${resort.slug}`
        }
        else {
            pathBase = `/${continent}/${resort.region.country.slug}/${resort.region.slug}/${resort.slug}`
        }
        if (resort.isSingle) monthIndex = 12;
        path = `${pathBase}-weather-${monthSlugs[monthIndex]}/`;
    }
    return path;
}

export const getLocationPathFromSearchResult = (searchResult: SearchResult, month: string): string => {
    let base = '/';
    base += searchResult.con;
    if (searchResult.cou != searchResult.reg && searchResult.t != 'con') {
        base += '/' + searchResult.cou;
    }
    if (searchResult.reg) {
        base += '/' + searchResult.reg;
    }
    if (searchResult.res) {
        base += '/' + searchResult.res;
    }
    base += '-weather-';
    base += (searchResult.t == 'res' && !searchResult.isMulti) ? 'climate' : month;
    base += '/';
    return base;
}